<script setup>
defineProps({
  // [{ key, label, value, disable? }]
  options: {
    type: Array,
    required: true,
  },
  inline: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits(['update'])
</script>
<template>
  <div :class="inline ? 'row items-center q-gutter-x-md' : 'column'">
    <q-toggle
      v-for="option in options"
      :key="option.key"
      :model-value="option.value"
      :label="option.label"
      :disable="option.disable"
      @update:model-value="value => emit('update', option.key, value)"
    />
  </div>
</template>
